import { axios, createFormData, handleError } from '../axios';

export const editCategory = (data) => {
  return new Promise((resolve) => {
    axios
      .post('admin/category/edit', createFormData(data))
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
